export class Env {
  private static getClientEnvironment(): NodeJS.ProcessEnv {
    return process.env;
  }

  public static isDevelop(): boolean {
    return Env.getClientEnvironment().NODE_ENV === 'development';
  }
}
